import React, { useMemo } from 'react';
import { Box, Text, } from '@common-fe/common-fe';
import _ from 'lodash';

import { EMPTY_FIELD_VALUE } from '@/common/constants';
import { RoleLevel } from '@/modules/role/role.types';


interface Props {
  level?: RoleLevel;
}
const RoleLevelLabel: React.FC<Props> = ({ level }) => {
  const formattedLevel = useMemo(() => {
    return _.capitalize(level);
  }, [level]);
  if(!level) {
    return (
      <Text data-testid="role-level-label_empty">
        {EMPTY_FIELD_VALUE}
      </Text>
    );
  }
  return (
    <Box align="center" data-testid="role-level-label" round="snackbarRound" background="border1" pad={{ horizontal: 'xxs' }}>
      <Text size="xsmall" style={{lineHeight: '18px'}} color="textBody">
        {formattedLevel}
      </Text>
    </Box>
  );
};

export default RoleLevelLabel;